<template>
<v-snackbar
  :timeout="msg.time"
  multi-line
  :color="msg.type"
  v-model="msg.show"
>
  <!-- <v-icon class="mr-2" :color="msg.type" large>{{msg.type == 'success' ? 'done' : msg.type}}</v-icon> -->
  <span class="white--text subheading"><b>{{msg.msg}}</b></span>
  <v-btn color="white" @click.native="dismissAppMsg" icon flat>
    <v-icon>close</v-icon>
  </v-btn>
</v-snackbar>
</template>

<script>
export default {
  props: ['msg'],
  methods: {
    dismissAppMsg () {
      this.$store.dispatch('resetAppMsg')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/general/AppMsg.vue